import { createContext, useContext } from 'react';

/**
 * Notification Context
 * Provides real-time notification state and actions throughout the app
 */
export const NotificationContext = createContext({
  // Connection state
  connectionState: 'Disconnected',
  isConnected: false,
  connectionId: null,
  
  // Notifications
  notifications: [],
  unreadCount: 0,
  
  // Actions
  connect: () => {},
  disconnect: () => {},
  refreshConnection: () => {},
  clearNotifications: () => {},
  removeNotification: () => {},
  markAsRead: () => {},
  markAllAsRead: () => {},
  refreshUnreadCount: () => {},
  
  // Error state
  error: null,
  isConnecting: false,
});

/**
 * Hook to use notification context
 * @throws {Error} if used outside NotificationProvider
 */
export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  
  if (!context) {
    throw new Error('useNotificationContext must be used within NotificationProvider');
  }
  
  return context;
};

